// extracted by mini-css-extract-plugin
module.exports = {"LegalContracts":"index-module_LegalContracts_YbQ0r","rightIcon":"index-module_rightIcon_ELqCO"};